import { Box, CircularProgress } from '@frontierag/frontier-ui-library';

import { useStyles } from './styles';
import type { IBoxLoader } from './types';

function BoxLoader({ centered }: IBoxLoader) {
  const styles = useStyles(centered);

  return (
    <Box position="absolute" left={0} right={0} top={0} bottom={0} zIndex={99}>
      <CircularProgress sx={styles.loader} />
    </Box>
  );
}

export default BoxLoader;
